export { default } from './FooterPanel'
